import "./components/_scaleRoot";
$(".inner").scaleRoot({
    scaleMode: (viewportIsMobile($("body").outerWidth())) ? 'containWidth' : 'cover'
});

// $(".inner:not(.detect-iframe > .outer > #scrollContent, .popup-sn2020 .inner)").scaleRoot({
//     scaleMode: (viewportIsMobile($("body").outerWidth())) ? 'containWidth' : 'cover'
// });



function viewportIsMobile(width) {
    return (width < 1025);
}

import "./components/_lightbox";



import MobileDetect from "mobile-detect"

var md = new MobileDetect(window.navigator.userAgent);


if ($(".getLink").length > 0) {

    switch (md.os()) {
        case 'AndroidOS':
            $(".getLink").addClass("open-download-and");
            $(".open-download-and").click(function (e) {
                e.preventDefault();

                $(".popup--download-android").addClass("active");
            });
            break;
        case 'iOS':
            $(".getLink").attr("href", $(".getLink-ios").attr("href"));
            break;
        default:
    }

}
$(document).ready(function () {
    init_stickybar()
});



// function randomBg() {
//     var randomIndex = Math.floor((Math.random() * 2) + 1);
//     if (randomIndex == 2) {
//         // $('.section--1 .random-second').addClass('active');
//         // $('.section--1 .random-first').remove('active');
//         $('.section--1 .random-first').addClass('active');
//         $('.section--1 .random-second').remove('active');
//         // loadAnotherVideo('http://img.zing.vn/products/vltkm/events/JXM-Subweb-Vo-lam-ky-tai/video/video-002.mp4');
//     }
//     else {
//         $('.section--1 .random-first').addClass('active');
//         $('.section--1 .random-second').remove('active');
//         // loadAnotherVideo('http://img.zing.vn/products/vltkm/events/JXM-Subweb-Vo-lam-ky-tai/video/video-001.mp4')
//     }
// }
// function loadAnotherVideo(linkVid) {
//     var video = document.getElementById('bgvid');
//     var source = video.querySelector('source');
//     source.setAttribute('src', linkVid);
//     video.appendChild(source);
//     video.load();
//     video.play();
// }

var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Desktop: function () {
        return navigator.userAgent.match(/Windows NT/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
var IsOpen = false;
$(".opennav").on("click", function (e) {
    e.preventDefault();
    if (!IsOpen) {
        $(".sub-nav-mb").addClass("Open");
        $(".opennav").addClass("toclose is-active");
        IsOpen = true;
    }
    else {
        $(".sub-nav-mb").removeClass("Open");
        $(".opennav").removeClass("toclose is-active");
        IsOpen = false;
    }
});

function init_stickybar() {
    if ($('.aside-right').length > 0) {
        $(".aside-right .bt-control").click(function () {
            if ($(this).hasClass("close")) {

                $(".aside-right").animate({
                    'right': 0
                }, 500, function () {

                    $('.bt-control').removeClass("close").addClass('open');
                });

            } else {
                if ($(window).width() < 768) {
                    $(".aside-right").animate({
                        'right': -90
                    }, 500, function () {
                        $('.bt-control').removeClass("open").addClass("close");

                    });
                }
                else {
                    $(".aside-right").animate({
                        'right': -230
                    }, 500, function () {
                        $('.bt-control').removeClass("open").addClass("close");

                    });
                }
            }
            return false;
        })

        if ($(window).outerWidth() < 1600) {
            $(".aside-right .bt-control").trigger("click");
        }
    }
}
// import "./components/_content-tab";
// import "./components/_frame-mp";
// import "./components/_control-side";
// import "./components/_progress";
import "./components/_watchIFrame";
